export const comments_tr = () => {
  const lang = document.documentElement.lang;
  const ptBrTranslations = {
    title: 'Comentários',
    placeholder: 'Escreva um comentário',
    btn_send: 'Publicar',
    no_results: 'Nenhum comentário.',
    load_more: 'Carregar Mais',
  };
  const translate = {
    'pt-br': ptBrTranslations,
    'pt-BR': ptBrTranslations,
    en: {
      title: 'Comments',
      placeholder: 'Write your comments',
      btn_send: 'Publish',
      no_results: 'No comments.',
      load_more: 'Load More',
    },
    es: {
      title: 'Comentarios',
      placeholder: 'Escribir um comentario',
      btn_send: 'Publicar',
      no_results: 'No hay comentarios.',
      load_more: 'Cargar Más',
    },
  };

  return translate[lang];
};
